/**
 * Feature flags that are monitored for analytics purposes.
 * This constant is used as the single source of truth for analytics feature flag defaults.
 */
export const watchedFlags = {
  'growth.ecomm.telemetry.event-kill-switch.operational': {},
  'ecomm.telemetry.all-dispos.rollout': false,
} as const;

export type AnalyticsFeatureFlags = Record<keyof typeof watchedFlags, any>;
